<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="1000" :fullscreen="hasActiveCustomFields" persistent fluid scrollable :content-class="!hasActiveCustomFields ? 'round-2xl' : ''")
  v-card(height="90vh")
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center {{ selectedPatient ? $t('edit') : $t('add') }} patient
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog('cancel')" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.basic200.pa-6
      v-form(ref="form")
        v-row
          v-col(:cols="hasActiveCustomFields ? 8 : 12")
            v-row
              v-col(cols="6")
                div.text-sm.font-semibold.neutral700--text Fill in patient information below
                div.text-sm.font-medium.neutral700--text.mt-4 Patient image
                div.d-flex.align-center.mt-3
                  div(style="width: 70px;")
                    v-responsive(:aspect-ratio="7/10")
                      v-card.fill-height.round-xl(v-if="resizeImageFileUrl" flat)
                        v-img(:src="resizeImageFileUrl" height="100%" width="100%")
                          template(v-slot:placeholder)
                            v-row(class="fill-height ma-0" align="center" justify="center")
                              v-progress-circular(indeterminate color="grey")
                      v-card.fill-height.round-xl(v-else outlined color="neutral100" style="border-color: var(--v-neutral300) !important;")
                        div.d-flex.align-center.justify-center.fill-height
                          v-icon(size="45") $yzi-user-03
                  div.file-change-layout.ml-4
                    div(style="width: 120px;")
                      y-button(:label="resizeImageFileUrl ? 'Update image' : 'Add image'" size="xs" outlined block)
                    input.input-change-layout(type="file" @change="onFileChange" accept="image/*" style="width: 120px !important")

                div.text-sm.font-medium.neutral700--text.mt-4 {{ $t('name') }}
                v-text-field.text-sm.mt-2.round-xl(v-model="patient.name" :placeholder="$t('name')" outlined dense :rules="rules.not_empty" background-color="neutral100" hide-details="auto")
                div.text-sm.font-medium.neutral700--text.mt-4 {{ $t('nric_passport') }}
                v-text-field.text-sm.mt-2.round-xl(v-model="patient.ic" :placeholder="$t('nric_passport')" outlined dense :rules="fields.ic ? rules.not_empty : []" background-color="neutral100" hide-details="auto")
                div.text-sm.font-medium.neutral700--text.mt-4 {{ $t('phone') }}
                phone-input.mt-2(v-model="patient.phone" required dense background-color="neutral100")
                div.text-sm.font-medium.neutral700--text.mt-4 {{ $t('email') }}
                v-text-field.text-sm.mt-2.round-xl(v-model="patient.email" :placeholder="$t('email')" outlined dense hide-details="auto" :rules="(fields.email || Boolean(patient.email)) ? rules.valid_email : []" background-color="neutral100")
                div.text-sm.font-medium.neutral700--text.mt-4 Date of birth
                v-text-field.text-sm.mt-2.round-xl(v-model="patient.dob" outlined dense hide-details="auto" type="date" :rules="fields.dob ? rules.not_empty : []" background-color="neutral100")
                div.text-sm.font-medium.neutral700--text.mt-4 Gender
                y-select.mt-2(v-model="patient.gender" :items="genders" item-text="text" item-value="value" :placeholder="$t('choose_gender')" :rules="fields.gender ? rules.not_empty_select : []" small background-color="neutral100")
                template(v-if="showStaffId")
                  div.text-sm.font-medium.neutral700--text.mt-4 {{ $t('staffid') }}
                  v-text-field.text-sm.mt-2.round-xl(v-model="patient.staff_id" :placeholder="$t('staffid')" outlined dense hide-details="auto" background-color="neutral100")

              v-col(cols="6")
                div.text-sm.font-medium.neutral700--text.mt-9 Nationality
                y-select.mt-2(v-model="patient.nationality" :items="countries" item-text="name" item-value="name" placeholder="Nationality" :rules="fields.nationality ? rules.not_empty_select : []" small background-color="neutral100")
                div.text-sm.font-medium.neutral700--text.mt-4 Race
                v-row.mt-2(no-gutters style="gap: 12px;")
                  v-col.grow
                    y-select(v-model="patient.race" :items="races" item-text="text" item-value="value" placeholder="Race" :rules="fields.race ? rules.not_empty_select : []" small background-color="neutral100")
                  v-col(v-if="patient.race === 'others'" cols="7")
                    v-text-field.text-sm.round-xl(v-model="otherRace" placeholder="Race" outlined dense hide-details="auto" :rules="fields.race ? rules.not_empty : []" background-color="neutral100")
                div.text-sm.font-medium.neutral700--text.mt-4 Religion
                v-row.mt-2(no-gutters style="gap: 12px;")
                  v-col.grow
                    y-select(v-model="patient.religion" :items="religions" item-text="text" item-value="value" placeholder="Religion" :rules="fields.religion ? rules.not_empty_select : []" small background-color="neutral100")
                  v-col(v-if="patient.religion === 'others'" cols="7")
                    v-text-field.text-sm.round-xl(v-model="otherReligion" placeholder="Religion" outlined dense hide-details="auto" :rules="fields.religion ? rules.not_empty : []" background-color="neutral100")
                .address
                  div.text-sm.font-medium.neutral700--text.mt-4 Address
                  v-text-field.text-sm.mt-2.round-xl(v-model="address.address_1" :placeholder="$t('address_1.label')" outlined dense :rules="(fields.address || !checkEmptyAddress(address)) ? rules.not_empty : []" background-color="neutral100" hide-details="auto")
                  v-text-field.text-sm.mt-2.round-xl(v-model="address.address_2" :placeholder="$t('address_2.label')" outlined dense background-color="neutral100" hide-details="auto")
                  v-text-field.text-sm.mt-2.round-xl(v-model="address.postcode" :placeholder="$t('postcode.label')" outlined dense :rules="(fields.address || !checkEmptyAddress(address)) ? rules.not_empty : []" background-color="neutral100" hide-details="auto" @keyup="fetchPostcodes(address.postcode, address, 'isFetchingAddress')")
                  v-text-field.text-sm.mt-2.round-xl(v-model="address.city" :placeholder="$t('city.label')" outlined dense :rules="(fields.address || !checkEmptyAddress(address)) ? rules.not_empty : []" background-color="neutral100" hide-details="auto" :loading="isFetchingAddress")
                  v-text-field.text-sm.mt-2.round-xl(v-model="address.state" :placeholder="$t('state.label')" outlined dense :rules="(fields.address || !checkEmptyAddress(address)) ? rules.not_empty : []" background-color="neutral100" hide-details="auto" :loading="isFetchingAddress")
                  v-text-field.text-sm.mt-2.round-xl(v-model="address.country" :placeholder="$t('country.label')" outlined dense :rules="(fields.address || !checkEmptyAddress(address)) ? rules.not_empty : []" background-color="neutral100" hide-details="auto" :loading="isFetchingAddress")
                .emergency-contact
                  div.text-sm.font-medium.neutral700--text.mt-4 Emergency contact name
                  v-text-field.text-sm.mt-2.round-xl(v-model="patient.emergency_name" placeholder="Emergency contact name" outlined dense :rules="fields.emergency_contact ? rules.not_empty : []" background-color="neutral100" hide-details="auto")
                  div.text-sm.font-medium.neutral700--text.mt-4 Emergency contact phone
                  phone-input.mt-2(v-model="patient.emergency_phone" :required="fields.emergency_contact" dense background-color="neutral100")

            yz-divider.my-6
            patient-panel-section.mt-6(:items.sync="staffIdItems")

          v-col(v-if="hasActiveCustomFields" cols="4")
            div.d-flex.fill-height
              v-divider(vertical)
              div.pl-6
                div.text-sm.font-semibold.neutral700--text Additional info
                div.text-xs.neutral700--text This is the field that has been setup in your registration settings
                div(v-for="(field, cfindex) in customFields" :key="`cf-${cfindex}`")
                  div.text-sm.font-medium.neutral700--text.mt-4 {{ field.extra_options.display_name || field.field_name }}
                  template(v-if="field.datatype === 'string'")
                    v-text-field.text-sm.mt-2.round-xl(v-model="field.value" :placeholder="field.extra_options.placeholder || 'Enter text'" outlined dense :rules="field.extra_options.required ? rules.not_empty : []" background-color="neutral100" hide-details="auto")
                  template(v-if="field.datatype === 'number'")
                    v-text-field.text-sm.mt-2.round-xl(v-model="field.value" :placeholder="field.extra_options.placeholder || 'Enter number'" outlined dense :rules="field.extra_options.required ? rules.not_empty : []" background-color="neutral100" hide-details="auto" type="number")
                  template(v-if="field.datatype === 'text'")
                    v-textarea.text-sm.mt-2.round-xl(v-model="field.value" :placeholder="field.extra_options.placeholder || 'Enter text'" outlined :rules="field.extra_options.required ? rules.not_empty : []" background-color="neutral100" hide-details="auto" auto-grow rows="3")
                  template(v-if="field.datatype === 'date'")
                    v-text-field.text-sm.mt-2.round-xl(v-model="field.value" outlined dense hide-details="auto" type="date" :rules="field.extra_options.required ? rules.not_empty : []" background-color="neutral100")
                  template(v-if="field.datatype === 'phone'")
                    phone-input.mt-2(v-model="field.value" :required="field.extra_options.required" dense background-color="neutral100")
                  template(v-if="field.datatype === 'email'")
                    v-text-field.text-sm.mt-2.round-xl(v-model="field.value" :placeholder="field.extra_options.placeholder || 'Enter email'" outlined dense :rules="field.extra_options.required ? rules.valid_email : []" background-color="neutral100" hide-details="auto")
                  template(v-if="field.datatype === 'selection'")
                    //- radio button
                    template(v-if="field.extra_options.type === 'radiobtn'")
                      v-radio-group.mt-2(v-model="field.value" dense :rules="field.extra_options.required ? rules.not_empty : []" hide-details="auto")
                        template(v-for="(choice, cindex) in field.extra_options.choices")
                          v-radio(:value="choice" :key="`ch-${cfindex}-${cindex}`")
                            template(#label)
                              div.text-sm.font-normal.neutral700--text {{ choice }}
                        template(v-if="field.extra_options.enable_other")
                          v-radio(value="other_option")
                            template(#label)
                              div.text-sm.font-normal.neutral700--text Other
                          v-text-field.text-sm.round-xl.ml-8(v-if="field.value === 'other_option'" v-model="field.other_value" :placeholder="`Enter ${field.extra_options.display_name || field.field_name || 'option'}`" outlined dense :rules="field.extra_options.required ? rules.not_empty : []" background-color="neutral100" hide-details="auto")
                    //- checkbox
                    template(v-else-if="field.extra_options.type === 'checklist'")
                      template(v-for="(choice, cindex) in field.extra_options.choices")
                        v-checkbox(v-model="field.value" :value="choice" :key="`ch-${cfindex}-${cindex}`" on-icon="$yzi-check-square-solid" off-icon="$yzi-checkbox-uncheck" dense multiple hide-details="auto" :rules="field.extra_options.required ? rules.not_empty_array : []")
                          template(#label)
                            div.text-sm.font-normal.neutral700--text {{ choice }}
                      template(v-if="field.extra_options.enable_other")
                        v-checkbox(v-model="field.value" value="other_option" on-icon="$yzi-check-square-solid" off-icon="$yzi-checkbox-uncheck" dense multiple hide-details="auto" :rules="field.extra_options.required ? rules.not_empty_array : []")
                          template(#label)
                            div.text-sm.font-normal.neutral700--text Other
                        v-text-field.text-sm.round-xl.ml-8(v-if="field.value && field.value.includes('other_option')" v-model="field.other_value" :placeholder="`Enter ${field.extra_options.display_name || field.field_name || 'option'}`" outlined dense :rules="field.extra_options.required ? rules.not_empty : []" background-color="neutral100" hide-details="auto")
                  template(v-if="field.datatype === 'address'")
                    .address
                      v-text-field.text-sm.mt-2.round-xl(v-model="field.value.address_1" :placeholder="$t('address_1.label')" outlined dense :rules="(field.extra_options.required || !checkEmptyAddress(field.value)) ? rules.not_empty : []" background-color="neutral100" hide-details="auto")
                      v-text-field.text-sm.mt-2.round-xl(v-model="field.value.address_2" :placeholder="$t('address_2.label')" outlined dense hide-details="auto")
                      v-text-field.text-sm.mt-2.round-xl(v-model="field.value.postcode" :placeholder="$t('postcode.label')" outlined dense :rules="(field.extra_options.required || !checkEmptyAddress(field.value)) ? rules.not_empty : []" background-color="neutral100" hide-details="auto" @keyup="fetchPostcodes(field.value.postcode, field.value, 'isFetchingCustomAddress')")
                      v-text-field.text-sm.mt-2.round-xl(v-model="field.value.city" :placeholder="$t('city.label')" outlined dense :rules="(field.extra_options.required || !checkEmptyAddress(field.value)) ? rules.not_empty : []" background-color="neutral100" hide-details="auto" :loading="isFetchingCustomAddress")
                      v-text-field.text-sm.mt-2.round-xl(v-model="field.value.state" :placeholder="$t('state.label')" outlined dense :rules="(field.extra_options.required || !checkEmptyAddress(field.value))? rules.not_empty : []" background-color="neutral100" hide-details="auto" :loading="isFetchingCustomAddress")
                      v-text-field.text-sm.mt-2.round-xl(v-model="field.value.country" :placeholder="$t('country.label')" outlined dense :rules="(field.extra_options.required || !checkEmptyAddress(field.value)) ? rules.not_empty : []" background-color="neutral100" hide-details="auto" :loading="isFetchingCustomAddress")
    
    v-divider
    v-card-actions.py-3.px-6
      v-btn.button-md.underline.px-0(text @click="closeDialog('cancel')") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(color="primary" depressed :loading="isLoading" @click="saveData") {{ $t('save') }}

</template>

<script>
import { resizeImage } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import { countries } from '@/assets/countries.js'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'
import PatientPanelSection from '@/components/clinic/panel/PatientPanelSection.vue'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    selectedPatient: {
      type: Object,
      default: null
    }
  },
  components: { PhoneInput, PatientPanelSection },
  data () {
    return {
      isLoading: false,
      isFetchingAddress: false,
      isFetchingCustomAddress: false,
      otherRace: null,
      otherReligion: null,
      resizeImageFile: null,
      resizeImageFileUrl: '',
      genders: [
        { text: 'Male', value: 'male' },
        { text: 'Female', value: 'female' },
      ],
      customFields: [],
      oriCustomFields: [],
      fields: {},
      patient: {},
      address: {},
      staffIdItems: [
        { panel: null, staffId: null }
      ],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
        not_empty_array: [v => Array.isArray(v) || 'This field is required', v => (Array.isArray(v) && v.length > 0) || 'Please select at least one option' ],
        valid_email: [ v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({ 
      company: 'getCompany',
      races: 'clinic/getRaces',
      religions: 'clinic/getReligions',
      custom_fields: 'clinic/getCustomFields',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    showStaffId () {
      if (this.company.genes.find(gene => gene.feature === 'show_staff_id_registration')) return true
      
      return false
    },
    countries () {
      return countries
    },
    hasActiveCustomFields () {
      return this.custom_fields.length > 0
    },
    columnSize () {
      return this.hasActiveCustomFields ? 4 : 6
    }
  },
  mounted () {
    this.fetchFormFields()
    if (this.selectedPatient) {
      let data = JSON.parse(JSON.stringify(this.selectedPatient))
      if (data.race && !['melayu', 'cina', 'india', 'bumiputera'].includes(data.race)) {
        this.otherRace = data.race
        data.race = 'others'
      }
      if (data.religion && !['islam', 'buddha', 'hindu', 'kristian'].includes(data.religion)) {
        this.otherReligion = data.religion
        data.religion = 'others'
      }
      if (data.emergency_contact && Object.keys(data.emergency_contact).length > 0) {
        data.emergency_name = data.emergency_contact?.name || null
        data.emergency_phone = data.emergency_contact?.phone || null
      }
      if (data.address) {
        this.address = data.address
      }
      if (data.custom_data.length) {
        let customData = JSON.parse(JSON.stringify(data.custom_data))
        this.setCustomFields(customData)
      } else {
        this.setCustomFields()
      }
      if (data.profile_image) {
        this.resizeImageFileUrl = data.profile_image.file
      }
      if (data.panels && data.panels.length > 0) {
        this.staffIdItems = data.panels.map(p => ({
          panel: p.panel,
          staffId: p.staff_id
        }))
      }
      delete data.address
      delete data.profile_image
      delete data.id
      this.patient = data
    } else {
      this.setCustomFields()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setCustomFields (customData) {
      if (!this.hasActiveCustomFields) { return }
      let customFields = JSON.parse(JSON.stringify(this.custom_fields))
      let newFields = []
      if (customData) {
        customFields.forEach(cf => {
          cf.value = cf.datatype === 'address' ? {} : null
          let found = customData.find(cd => cd.id === cf.id)
          if (found) {
            if (cf.datatype === 'selection') {
              if (cf.extra_options.type === 'radiobtn') {
                found.value = found.value[0]
                if (!cf.extra_options.choices.includes(found.value)) {
                  found.other_value = found.value
                  found.value = 'other_option'
                }
              } else {
                found.value = found.value.map(m => {
                  if (!cf.extra_options.choices.includes(m)) {
                    found.other_value = m
                    return 'other_option'
                  }
                  return m
                })
              }
            }
            newFields.push({ ...cf, ...found })
          }
        })
      } else {
        newFields = customFields.map(m => { return { ...m, value: m.datatype === 'address' ? {} : null } })
      }
      this.customFields = JSON.parse(JSON.stringify(newFields))
      this.oriCustomFields = JSON.parse(JSON.stringify(newFields))
    },
    fetchFormFields () {
      this.$axios.get(`/clinics/${this.company.slug}/registrations/form_fields`)
        .then(resp => {
          let fields = {}
          resp.data.forEach(o => {
            fields[o.field] = o.required
          })
          this.fields = fields
        })
    },
    fetchPostcodes (val, address, fetching) {
      if (!val) {
        return
      }
      if (val.length !== 5) {
        return
      }
      this[fetching] = true
      this.$axios.get(`/shipping/postcodes?postcode=${address.postcode}`).then((response) => {
        const addresses = response.data
        if (addresses.length > 0 && addresses[0].postcode) {
          this.$set(address, 'city', addresses[0].city)
          this.$set(address, 'state', addresses[0].state)
          this.$set(address, 'country', addresses[0].country)
        }
      })
      .catch(() => {})
      .finally(() => {
        this[fetching] = false
      })
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', 'Please fill in the required fields'])
        return
      }
      if (this.fields.profile_image && !this.resizeImageFileUrl) {
        this.showMessage(['error', 'Patient image is required'])
        return
      }
      this.isLoading = true
      if (this.selectedPatient) {
        let data = {
          ...this.patient,
        }
        if (this.patient.religion === 'others') {
          data.religion = this.otherReligion
        }
        if (this.patient.race === 'others') {
          data.race = this.otherRace
        }
        if (this.patient.emergency_name || this.patient.emergency_phone) {
          data.emergency_contact = {
            name: this.patient.emergency_name || '',
            phone: this.patient.emergency_phone || ''
          }
        }
        if (!this.checkEmptyAddress(this.address)){
          data.address = this.address
        }
        if (this.staffIdItems && this.staffIdItems.length > 0) {
          data.panels = this.staffIdItems
            .filter(item => item.panel)
            .map(item => ({
              panel: item.panel.id,
              staff_id: item.staffId
            }))
        }
        let formdata = new FormData()
        if (this.resizeImageFile) {
          formdata.append('profile_image', this.resizeImageFile)
        }
        this.$axios.patch(`/clinics/${this.company.slug}/patients/${this.selectedPatient.id}`, data)
          .then(() => {
            if (this.resizeImageFile) {
              this.$axios.patch(`/clinics/${this.company.slug}/patients/${this.selectedPatient.id}`, formdata)
                .catch(() => {})
            }
            if (this.hasActiveCustomFields) {
              let customData = this.customFields.map(m => {
                let field = { ...m }
                if (field.datatype === 'selection') {
                  if (field.extra_options.type === 'radiobtn') {
                    if (field.value === 'other_option') {
                      field.value = field.other_value
                    }
                    field.value = field.value ? [field.value] : []
                  } else {
                    if (field.value && field.value.includes('other_option')) {
                      field.value = field.value.map(v => v === 'other_option' ? field.other_value : v)
                    } else if (!field.value) {
                      field.value = []
                    }
                  }
                }
                return field
              })
              this.$axios.post(`/clinics/${this.company.slug}/patients/${this.selectedPatient.id}/custom_data`, { custom_data: customData })
                .then(() => {
                  this.showMessage(['success', 'Patient updated successfully'])
                  this.closeDialog('edit')
                })
                .catch(err => {
                  let message = 'An error has occurred. Unable to update the custom fields.'
                  if (err.response.data?.length > 0) {
                    message = err.response.data[0]
                  } else if (err.response.data) {
                    let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                    if (data) { message = data  }
                  }
                  this.showMessage(['error', message])
                })
                .finally(() => {
                  this.isLoading = false
                })
            } else {
              this.showMessage(['success', 'Patient updated successfully'])
              this.closeDialog('edit')
              this.isLoading = false
            }
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data?.length > 0) {
              message = err.response.data[0]
            } else if (err.response.data) {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data  }
            }
            this.showMessage(['error', message])
            this.isLoading = false
          })
      } else {
        let data = {
          ...this.patient,
          source: 'admin'
        }
        if (this.patient.religion === 'others') {
          data.religion = this.otherReligion
        }
        if (this.patient.race === 'others') {
          data.race = this.otherRace
        }
        if (this.patient.emergency_name || this.patient.emergency_phone) {
          data.emergency_contact = {
            name: this.patient.emergency_name || '',
            phone: this.patient.emergency_phone || ''
          }
        }
        if (!this.checkEmptyAddress(this.address)) {
          data.address = this.address
        }
        if (this.staffIdItems && this.staffIdItems.length > 0) {
          data.panels = this.staffIdItems
            .filter(item => item.panel && item.staffId)
            .map(item => ({
              panel: item.panel.id,
              staff_id: item.staffId
            }))
        }
        let formdata = new FormData()
        if (this.resizeImageFile) {
          formdata.append('profile_image', this.resizeImageFile)
        }
        this.$axios.post(`/clinics/${this.company.slug}/patients`, data)
          .then(resp => {
            if (this.resizeImageFile) {
              this.$axios.patch(`/clinics/${this.company.slug}/patients/${resp.data.id}`, formdata)
                .catch(() => {})
            }
            if (this.hasActiveCustomFields) {
              let customData = this.customFields.map(m => {
                let field = {...m }
                if (field.datatype === 'selection') {
                  if (field.extra_options.type === 'radiobtn') {
                    if (field.value === 'other_option') {
                      field.value = field.other_value
                    }
                    field.value = [field.value]
                  } else {
                    if (field.value && field.value.includes('other_option')) {
                      field.value = field.value.map(v => v === 'other_option' ? field.other_value : v)
                    } else if (!field.value) {
                      field.value = []
                    }
                  }
                }
                return field
              })
              this.$axios.post(`/clinics/${this.company.slug}/patients/${resp.data.id}/custom_data`, { custom_data: customData })
                .then(() => {
                  this.showMessage(['success', 'Patient registered successfully'])
                  this.closeDialog('add')
                })
                .catch(err => {
                  let message = 'An error has occurred. Unable to update the custom fields.'
                  if (err.response.data?.length > 0) {
                    message = err.response.data[0]
                  } else if (err.response.data) {
                    let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                    if (data) { message = data  }
                  }
                  this.showMessage(['error', message])
                })
                .finally(() => {
                  this.isLoading = false
                })
            } else {
              this.showMessage(['success', 'Patient registered successfully'])
              this.closeDialog('add')
              this.isLoading = false
            }
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data?.length > 0) {
              message = err.response.data[0]
            } else if (err.response.data) {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data  }
            }
            this.showMessage(['error', message])
            this.isLoading = false
          })
      }
    },
    checkEmptyAddress (address) {
      if (Object.keys(address).length === 0) {
        return true
      } else if (Object.values(address).every(val => !val)) {
        return true
      }
      return false
    },
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'company_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    closeDialog (action) {
      this.$emit('closed', action)
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>

<i18n>
{
  "en": {
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    }
  },
  "id": {
   "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    }
  }
}
</i18n>